import { HTMLAttributes } from 'react';

import { StyledSkeleton } from './styles';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
  gradientColor?: string;
}
const Skeleton = (props: SkeletonProps) => {
  return <StyledSkeleton {...props} />;
};

export default Skeleton;
